import React, { useCallback, useEffect, useState } from "react";
import { makeStyles, Grid, Card, CardMedia, CardContent, Typography, Box } from "@material-ui/core";
import { useExecute, useFetch } from "Hooks/useFetch";
import { callWebApi } from "Common/Utility/Api";
import { useMessageBox } from "Hooks/useMessageBox";
import { useHistory } from "react-router-dom";
import { MenuIndex, getMenuInfo } from "Component/Menu";
import { AppActionTypes, AppProvider } from "App";
import { Contact } from "Models/Contact";
import { CancelTokenSource } from "axios";

const unselectServiceImage =
  "data:image/png;base64,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";

const useStyles = makeStyles((theme) => ({
  vendorBox: {
    padding: theme.spacing(2),
  },
  vendorName: {
    fontSize: 20,
  },
  card: {
    paddingTop: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    minHeight: 210,
    maxHeight: 210,
  },
  media: {
    display: "block",
    margin: "auto",
    maxWidth: 128,
    maxHeight: 128,
    minWidth: 128,
    minHeight: 128,
  },
  nomedia: {
    display: "block",
    margin: "auto",
    maxWidth: 128,
    maxHeight: 128,
    minWidth: 128,
    minHeight: 128,
    visibility: "hidden",
  },
  content: {
    textAlign: "center",
  },
  title: {
    maxWidth: 128,
    minWidth: 128,
  },
}));

type Service = {
  id: string;
  name: string;
};

interface ServiceCardProps {
  vendorId: string;
  service: Service | null;
  onClick: (vendorId: string, service: Service | null) => void;
}

const ServiceCard = (props: ServiceCardProps) => {
  const classes = useStyles();
  const [image, setImage] = useState<string>();

  const title = props.service?.name ?? "問い合わせ全般";

  const renderImage = (image: Blob) => {
    if (image.size === 0) {
      return;
    }

    var reader = new FileReader();
    reader.onload = (event) => {
      setImage(event.target!.result as string);
    };
    reader.readAsDataURL(image);
  };

  useFetch(
    useCallback(
      async (signal: CancelTokenSource) => {
        if (!props.service) {
          setImage(unselectServiceImage);
          return;
        }

        const response = await callWebApi().get<Blob>("/relation/serviceimage", {
          cancelToken: signal.token,
          params: { serviceId: props.service.id },
          responseType: "blob",
        });
        renderImage(response.data);
      },
      [props.service]
    )
  );

  return (
    <Card className={classes.card} onClick={() => props.onClick(props.vendorId, props.service)}>
      <CardMedia className={image ? classes.media : classes.nomedia} title={title} component="img" src={image} />
      <CardContent className={classes.content}>
        <Typography className={classes.title}>{title}</Typography>
      </CardContent>
    </Card>
  );
};

type Vendor = {
  id: string;
  name: string;
  services: (Service | null)[]; // nullはサービスを指定しない問い合わせ全般を表す
};
type VenderList = { [key: string]: Vendor };

export default React.memo(() => {
  const classes = useStyles();
  const message = useMessageBox();
  const history = useHistory();

  const appDispatch = AppProvider.useDispatch();
  const master = AppProvider.useGlobalState("master");

  const [venders, setVenders] = useState<VenderList>({});

  useEffect(() => {
    const venders: VenderList = {};
    if (master.services) {
      master.services.forEach((service) => {
        if (venders[service.vendorId] == null) {
          venders[service.vendorId] = {
            id: service.vendorId,
            name: service.vendorName,
            services: [null],
          };
        }
        venders[service.vendorId].services.push({
          id: service.serviceId!,
          name: service.name!,
        });
      });
    }
    setVenders(venders);
  }, [master.services]);

  const executePost = useExecute(
    useCallback(
      async (unmounted: { value: boolean }, object: { vendorId: string; service: Service | null; history: any }) => {
        const response = await callWebApi().post<Contact>("/contacts/to", {
          vendorId: object.vendorId,
          serviceId: object.service?.id,
          serviceName: object.service?.name,
        });

        if (unmounted.value) {
          return;
        }

        appDispatch({ type: AppActionTypes.SET_TRANSITION, value: response.data });
        object.history.push(getMenuInfo(MenuIndex.ContactTo).path);
      },
      [appDispatch]
    )
  );

  const handleOnClick = async (vendorId: string, service: Service | null) => {
    if (await message.confirm("確認", "問い合わせをしますか？")) {
      executePost({ vendorId: vendorId, service: service, history: history });
    }
  };

  return (
    <>
      {Object.values(venders).map((vendor) => {
        return (
          <Box className={classes.vendorBox} key={vendor.id}>
            <Typography className={classes.vendorName}>{vendor.name}</Typography>
            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
              {vendor.services.map((service, index) => (
                <Grid key={vendor.id + index} item>
                  <ServiceCard vendorId={vendor.id} service={service} onClick={handleOnClick} />
                </Grid>
              ))}
            </Grid>
          </Box>
        );
      })}
    </>
  );
});
